module.exports = __webpack_public_path__ + "assets/img/11_1081_big.f4e14966.jpg";